import React from "react";
import Icon from "../ui/Icon";

interface ErrorMessageProps {
  message: string;
  type?: "error" | "warning" | "info";
  onDismiss?: () => void;
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  type = "error",
  onDismiss,
  className = "",
}) => {
  const typeClasses = {
    error: "bg-red-50 border-red-200 text-red-800",
    warning: "bg-yellow-50 border-yellow-200 text-yellow-800",
    info: "bg-blue-50 border-blue-200 text-blue-800",
  };

  return (
    <div
      className={`p-4 border rounded-lg flex items-center justify-between ${typeClasses[type]} ${className}`}
    >
      <span className="text-sm">{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="ml-4 hover:bg-opacity-20 hover:bg-gray-500 rounded-full p-1"
        >
          <Icon name="chevronRight" size="sm" className="rotate-45" />
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
